<template>
  <div class="typepageheight">
    <!-- <wv-header :title="$store.state.rootglobal.pagetitle" v-if="borwser==''" style="color:#999;" :fixed="false" background-color="#f7f7fa">
    </wv-header>-->
    <router-view></router-view>

    <wv-tabbar :fixed="true">
      <wv-tabbar-item @click="tabbarclick('/app/home',1)" :is-on="getison('/app/home')">
        <span slot="icon" style="display: inline-block; position: relative;">
          <img
            class="weui-tabbar__icon"
            v-bind:src="getison('/app/home')==true?c_home:home"
            slot="icon"
          />
        </span>
        首页
      </wv-tabbar-item>

      <wv-tabbar-item  @click="tabbarclick('/page/mustpushtoday',5)" :is-on="getison('/page/mustpushtoday')" >
        <span slot="icon" style="display: inline-block; position: relative;">
          <img
            class="weui-tabbar__icon"
            v-bind:src="getison('/page/mustpushtoday')==true?c_sort:sort"
            slot="icon"
          />
        </span>
        全部产品
      </wv-tabbar-item>

      <wv-tabbar-item
        v-if="isShowFun"
        @click="tabbarclick('/app/fun',2)"
        :is-on="getison('/app/fun')"
      >
        <span slot="icon" style="display: inline-block; position: relative;">
          <img
            class="weui-tabbar__icon"
            v-bind:src="getison('/app/fun')==true?c_combo:combo"
            slot="icon"
          />
        </span>
        玩赚
      </wv-tabbar-item>

      <!-- <wv-tabbar-item @click="tabbarclick('/app/combo',2)" :is-on="getison(2)">
        <span slot="icon" style="display: inline-block; position: relative;">
          <img class="weui-tabbar__icon" v-bind:src="getison(2)==true?c_combo:combo" slot="icon">
        </span>
        精选
      </wv-tabbar-item>-->
      <!-- <wv-tabbar-item @click="tabbarclick('/app/blank',2)" :is-on="getison('/app/blank')">
        <span slot="icon" style="display: inline-block; position: relative;">
          <img
            class="weui-tabbar__icon"
            v-bind:src="getison('/app/blank')==true?c_order:order"
            slot="icon"
          />
        </span>
        空白
      </wv-tabbar-item> -->
      <wv-tabbar-item @click="tabbarclick('/app/order',3)" :is-on="getison('/app/order')">
        <span slot="icon" style="display: inline-block; position: relative;">
          <img
            class="weui-tabbar__icon"
            v-bind:src="getison('/app/order')==true?c_order:order"
            slot="icon"
          />
          <!-- <wv-badge is-dot style="position: absolute;top: 0;right: -6px;"></wv-badge> -->
        </span>
        订单
      </wv-tabbar-item>

      <wv-tabbar-item @click="tabbarclick('/app/my',4)" :is-on="getison('/app/my')">
        <img class="weui-tabbar__icon" v-bind:src="getison('/app/my')==true?c_us:us" slot="icon" />我的
      </wv-tabbar-item>
    </wv-tabbar>
  </div>
</template>
<script>
import { Toast } from "we-vue";
import home from "../../assets/img/home.png";
import c_home from "../../assets/img/c-home.png";
import combo from "../../assets/img/combo.png";
import c_combo from "../../assets/img/c-combo.png";
import order from "../../assets/img/order.png";
import c_order from "../../assets/img/c-order.png";
import us from "../../assets/img/us.png";
import c_us from "../../assets/img/c-us.png";
import sort from "../../assets/img/sort.png";
import c_sort from "../../assets/img/c_sort.png";
export default {
  name: "layout",
  data() {
    return {
      borwser: this.GLOBAL.borwser,
      isonindex: 0,
      isonrouter: "",
      home: home,
      c_home: c_home,
      order: order,
      c_order: c_order,
      combo: combo,
      c_combo: c_combo,
      unreadcount: 0,
      us: us,
      c_us: c_us,
      sort:sort,
      c_sort:c_sort,
      isShowFun: false
    };
  },
  created: function() {
    this.getIsShowFun();
  },
  mounted: function() {},
  methods: {
    tabbarclick: function(to, index) {
      this.getIsShowFun();
      this.$router.push(to);
      this.isonindex = index;
      this.isonrouter = to;
    },
    getIsShowFun: function() {
      var disid = localStorage.getItem("disid");
      var miniOpenId = "";
      if(window.__wxjs_environment == 'miniprogram')
      {
        miniOpenId = this.$route.query.miniOpenId;
      }
      if (disid != undefined && disid != null && disid.length > 0) {
        this.$http
          .get(this.GLOBAL.BASE_URL + "api/login/getisshowfun", {
            params: {
              disid: disid,
              miniOpenId:(miniOpenId==null?"":miniOpenId)
            }
          })
          .then(function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success && rep.Data) {
              this.isShowFun = true;
            } else {
              this.isShowFun = false;
            }
          });
      }
    }
  },
  computed: {
    getison() {
      //选中高亮
      return function(url) {
        return location.href.includes(url);
      };
    }
  }
};
</script>

<style>
body {
  background-color: #f8f8f8;
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/layout.vue